import { PROGRAMMATION_KEY } from './progAtoms';

export const progKeys = {
  list: (schoolyearId: string, schoolId: string, opt?: string) => [
    schoolyearId,
    schoolId,
    PROGRAMMATION_KEY,
    'list',
    opt,
  ],
};
